module.exports = __webpack_public_path__ + "img/BaliBody6.45b838d0.jpg";